/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class Dino extends Phaser.GameObjects.Container {
  constructor(scene, mName) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.walkSound = ABCyaPhaser.Audio.createSound(this.scene);

    this.charId = mName;
    this.eyePositions = [{ x: 168, y: 13 }, { x: 80, y: 30 }];
    this.eyeAnimDelay = 300;
    this.buildCharacter();
  }

  buildCharacter() {
    if (this.charId === 2) {
      this.body = this.scene.add.sprite(0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, `char-${this.charId.toString()}-idle`);
    }
    else {
      this.body = this.scene.add.sprite(0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, `char-${this.charId.toString()}-idle`).setOrigin(.5, 1);
    }

    this.add(this.body);

    // add eyes
    this.eyes = this.scene.add.sprite(0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, `eyes-${this.charId.toString()}-idle`).setOrigin(0, 0);
    this.add(this.eyes);
    this.eyes.x = this.eyePositions[this.charId - 1].x - this.body.getBounds().width / 2;
    this.eyes.y = this.charId === 1 ? this.eyePositions[this.charId - 1].y - this.body.getBounds().height : this.eyePositions[this.charId - 1].y - this.body.getBounds().height / 2;

    this.idleFlag = true;
    this.currentAnimation = `char-${this.charId.toString()}-idle`;
  };

  playIdle() {
    this.currentAnimation = `char-${this.charId.toString()}-idle`;
    this.idleFlag = true;
    this.extraAnimDelay = Phaser.Math.Between(150,300);
    this.body.stop();
    this.body.setFrame(`char-${this.charId.toString()}-idle`);
  };

  playHappy() {
    this.currentAnimation = `char-${this.charId.toString()}-happy`;
    this.idleFlag = false;
    this.body.play(`char-${this.charId.toString()}-happy`);
    this.body.once('animationcomplete', () => { this.playIdle(); });
  };

  playExtra() {
    this.currentAnimation = `char-${this.charId.toString()}-extra`;
    this.idleFlag = false;
    this.body.play(`char-${this.charId.toString()}-extra`);
    this.body.once('animationcomplete', () => { this.playIdle(); });
  };

  walkIn(endX,time,call) {
    this.currentAnimation = `char-${this.charId.toString()}-walk`;
    this.idleFlag = false;
    this.body.stop();
    this.body.setFrame(`char-${this.charId.toString()}-walk`);
    if (endX === null) endX = 100;
    if (time === null) time = 1000;

    const finishCall = call === null ? 'happy' : call;

    // add wiggle rotation tween
    const startY = this.y;
    ABCyaPhaser.Tweens.addTween(this, 100, { y: startY - 10, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this, time, { x: endX }, Phaser.Math.Easing.Linear, () => {
      this.finishWalk(finishCall);
    });

    this.playWalkSound();
  };

  danceAcross(time) {
    this.idleFlag = false;
    this.currentAnimation = `char-${this.charId.toString()}-walk`;
    this.body.stop();
    this.body.setFrame(`char-${this.charId.toString()}-walk`);

    this.angle = 0;

    // add wiggle rotation tween
    const startY = this.y;
    ABCyaPhaser.Tweens.addTween(this, 100, { y: startY - 10, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this, time, { x: this.scene.mid.x * 2 + 100 }, Phaser.Math.Easing.Linear, () => {
      this.finishWalk('idle');
    });

    this.playWalkSound();
  };

  danceAround() {
    if (this.scene) {
      let jumpDist = Phaser.Math.Between(-50,50);

      if (this.x + jumpDist >= this.scene.mid.x * 2 - this.getBounds().width || this.x + jumpDist < this.getBounds().width) jumpDist *= -1;

      ABCyaPhaser.Tweens.addTween(this, 400, { x: this.x + jumpDist }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.danceAround();
      });

      this.playHappy();
    }
  };

  finishWalk(call) {
    this.scene.tweens.killTweensOf(this);

    let finishCall;
    if (call === 'idle') {
      finishCall = this.playIdle();
    }
    else if (call === 'dance') {
      finishCall = this.danceAround();
    }
    else {
      finishCall = this.playHappy();
    }

    finishCall;
  };

  playWalkSound() {
    const snd = this.charId === 1 ? SoundAssetKeys._cartoon_tiptoe_1 : SoundAssetKeys._cartoon_tiptoe_2;
    ABCyaPhaser.Audio.playSound(snd, this.walkSound, .2);
    this.walkSound.on('complete', () => {this.repeatWalkSound();});
  };

  repeatWalkSound() {
    if (this.body && this.currentAnimation === `char-${this.charId.toString()}-walk`) {
      const snd = this.charId === 1 ? SoundAssetKeys._cartoon_tiptoe_1 : SoundAssetKeys._cartoon_tiptoe_2;
      ABCyaPhaser.Audio.playSound(snd, this.walkSound, .2);
      this.walkSound.on('complete', () => {this.repeatWalkSound();});
    }
    else {
      this.walkSound.stop();
    }
  };

  tick() {
    this.eyeAnimDelay--;
    if (this.eyeAnimDelay <= 0) {
      this.eyeAnimDelay = Math.round(Phaser.Math.Between(100,300));
      this.eyes.play(`eyes-${this.charId.toString()}-blink`);
    }

    const mAnimation = this.currentAnimation;

    if (this.idleFlag === false) {
      if (mAnimation === `char-${this.charId.toString()}-idle`) {
        this.playIdle();
      }
    }
    else {
      this.extraAnimDelay--;
      if (this.extraAnimDelay <= 0) {
        this.playExtra();
      }
    }

    if (mAnimation !== null) {
      if (mAnimation !== `char-${this.charId.toString()}-happy` && mAnimation !== 'char-1-extra') {// not happy nor sad
        this.eyes.alpha = 1;
      }
      else {
        this.eyes.alpha = 0;
      }
    }
  };
}